import { clientNeoActivite, clientNeoActiviteWS } from "@newrai/api-clients";
import { Header } from "@newrai/neonumy-ui";
import { useAuth } from "config/auth/useAuth";
import useStore from "config/store";
import useCompanyPermissions from "hooks/Permissions/useCompanyPermissions";
import { matchPath, useLocation } from "react-router-dom";
import LogoHome from "resources/images/neo-dashboard-home.svg?react";
import Logo from "resources/images/neo-dashboard.svg?react";
import { useGetAndSaveCompanies } from "views/Base/hooks/useGetAndSaveCompanies";
import { useQueryCompanyAccountingFirm } from "views/Base/hooks/useQueryCompanyAccountingFirm";
import { useMenuItems } from "./useMenuItems";

export function AppHeader() {
  const { logout } = useAuth();
  const location = useLocation();

  const userData = useStore(state => state.userData);
  const companySelected = useStore(state => state.companySelected);
  const accountingFirmSelected = useStore(state => state.accountingFirmSelected);
  const menuItems = useMenuItems();
  const { canViewCompaniesList, canNavigateWithCompany } = useCompanyPermissions();
  const { onSaveCompany } = useGetAndSaveCompanies();
  useQueryCompanyAccountingFirm();

  const displayCompanySelect =
    ["client"].includes(userData?.userCategory?.slug) && canViewCompaniesList;

  const isClientCompanyHome = !!matchPath("/company/:companyId", location.pathname);
  const isArticlesRoute =
    !!matchPath("/articles/:categoryId", location.pathname) ||
    !!matchPath("/articles/:categoryId/:articleId", location.pathname);

  const partialUserData = {
    firstName: userData?.firstName ?? "",
    lastName: userData?.lastName ?? "",
    email: userData?.email ?? "",
    category: userData?.userCategory?.slug ?? "",
    isNewraiUser: userData?.isNewraiUser ?? false,
  };

  const appsUrlParams = canNavigateWithCompany
    ? {
        companyId: companySelected?.id,
        accountingFirmId: accountingFirmSelected?.id,
      }
    : {};

  const currentDomain =
    import.meta.env.VITE_ENV === "local"
      ? "https://dashboard.development.neonumy.dev/"
      : window.location.hostname;

  const urlIsNewRai = currentDomain.includes("newrai.fr") || currentDomain.includes("neonumy.dev");
  const hasNeofeedAccess =
    (userData?.isSuperuser || userData?.permissions.includes("neofeed.can-access")) && urlIsNewRai;

  const isHome = location.pathname === "/";
  const neofeedReplacesNotifications = isHome && hasNeofeedAccess;
  const displayNotifications = !neofeedReplacesNotifications;

  return (
    <Header
      appLogo={
        isHome ? <LogoHome style={{ height: "30px" }} /> : <Logo style={{ height: "30px" }} />
      }
      appName="Dashboard"
      userData={partialUserData}
      companySelected={companySelected}
      accountingFirmSelected={accountingFirmSelected}
      appsUrlParams={appsUrlParams}
      showNeoAcademy={true}
      userAvatar={{
        profileHref: "/account/profile",
        handleLogout: logout,
      }}
      menuItems={menuItems}
      appsDrawerPersistent={isHome || isClientCompanyHome || isArticlesRoute}
      {...(displayNotifications && {
        notifications: {
          neoActiviteClientHttp: clientNeoActivite,
          neoActiviteClientWS: clientNeoActiviteWS,
        },
      })}
      {...(displayCompanySelect && {
        selectCompanyOptions: {
          isEditable: true,
          companyOnly: true,
          handleOnSelectCompany: onSaveCompany,
        },
      })}
    />
  );
}
